import React from 'react';
import { MDBIcon } from 'mdb-react-ui-kit';
import moment from 'moment';

const PrintHeader = ({ company, header, transportAccount, customer, userinfo }) => (
  <div className="print-header">
    <table>
      <tbody>
        <tr>
          <td rowSpan={3} ><img src="/company.png" alt="Company Logo" style={{ width: 'auto', height: '120px', marginRight: '20px' }} /></td>
          <td rowSpan={3}  >
            <table className='table header-table mt-2' style={{zoom:0.8}}>
              <tr>
                <td style={{ width: "40%" }}>
                  <table >
                    <tbody>
                      <tr>
                        <th style={{ width: "13%" }}>ผู้ขาย: </th>
                        <th>{company.name}</th>
                      </tr>
                      <tr>

                        <td colSpan={2}>{company.address}</td>
                      </tr>
                      <tr>
                        <th>เลขที่ภาษี: </th>
                        <td>{company.taxid}</td>
                      </tr>
                      <tr><td colSpan={2}></td></tr>
                      <tr><td colSpan={2}>
                          <table>
                        <tr>
                          <th>ติดต่อกลับที่: {userinfo.name}</th>
                        </tr>
                        <tr>
                          <td><MDBIcon fas icon="envelope" className='me-1' />
                          {userinfo.tel??"-"}<MDBIcon fas icon="globe"  className='me-1 ms-1'  />
                          {userinfo.email??"-"}</td>
                        </tr>
                        </table>
                      </td></tr>

                    </tbody>
                  </table>

                </td>
              </tr>
            </table>

          </td>
          <td style={{ textAlign: 'right' }}> {header.page} </td>
        </tr>
        <tr>
          <td style={{ textAlign: 'right' }}>({header.title})</td>
        </tr>

        <tr>
          <td style={{ textAlign: 'right' }}><h4 style={{whiteSpace:'nowrap'}}>{header.name}</h4></td>
        </tr>
      </tbody>
    </table>

    {/* <table >
            <tr>
              <th></th>
              <th>


              </th>
            </tr>
          </table> */}
    <table className='table header-table mt-2 mb-1'>
      <tr>
        <td style={{ width: "40%", borderTop: "1px solid #ccc"}}>
          <table >
            <tbody>
              <tr>
                <th style={{ width: "25%" }}>ลูกค้า: </th>
                <th>{customer.customer_id + ' ' + customer.name}</th>
              </tr>
              <tr>
                <th>ที่อยู่: </th>
                <td>{customer.address}</td>
              </tr>
              <tr>
                <th>เลขที่ภาษี: </th>
                <td>{customer.tax}{customer.branch?` (${customer.branch})`:""}</td>
              </tr>
            </tbody>
          </table>

        </td>
        <td style={{ width: "30%", borderTop: "1px solid #ccc" }} >
          <table >
            <tbody>
              <tr>
                <th style={{ width: "10%" }}><MDBIcon fas icon="phone-alt" /></th>
                <td>{customer.phone ?? "-"}</td>
              </tr>
              <tr>
                <th><MDBIcon fas icon="envelope" /></th>
                <td>{customer.email ?? "-"}</td>
              </tr>
              <tr>
                <th><MDBIcon fas icon="globe" /></th>
                <td>{customer.website ?? "-"}</td>
              </tr>
            </tbody>
          </table>
        </td>

        <td style={{ width: "30%" }} >
          <table name="documenttable" className='table bordered' style={{ backgroundColor: '#eee' }}>

            <tr>
              <th>เลขที่เอกสาร: </th>
              <td>{transportAccount.name}</td>
            </tr>
             <tr>
              <th>วันที่ออก: </th>
              <td>{moment(transportAccount.billdateobj).format("DD/MM/YYYY")}</td>
            </tr>
           {/* {!header.nodue && <tr>
              <th>วันครบกำหนด: </th>
              <td>{moment(transportAccount.duedateobj).format("DD/MM/YYYY")}</td>
            </tr>} */}

          </table>
        </td>
      </tr>

    </table>

  </div>
);

export default PrintHeader;